"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
const util_1 = require("../util");
class InsightsQueryClient {
    constructor(config) {
        const responseParser = this.parseResponse.bind(this);
        this.apiManager = new util_1.APIUtils.APIManager(config.insightsUrl, index_1.Insights.InsightsEndpoints, responseParser);
    }
    parseResponse(response) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { status, statusText, headers, url } = response;
            const result = { status, statusText, headers, url };
            try {
                const responseJson = yield response.json();
                result.data = responseJson;
            }
            catch (e) {
                console.error(e);
            }
            if (response.status >= 400 && response.status < 600) {
                throw new util_1.APIUtils.RequestError(result, ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message) || 'unknown error');
            }
            return result;
        });
    }
    // Chain api
    Stake(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('chain/stake', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    Transaction(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('chain/transaction', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    AvgBlockTime(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                hours: req.hours
            };
            const request = this.apiManager.path('chain/blocktime', {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    // User api
    ActiveAccounts(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('user/active', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserProfile(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('user/profile', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    UserGrowth(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('user/growth', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    TotalUsers(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('user/total', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    // Pool api
    Pools(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('pool/list', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    PoolHistory(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('pool/history', {}, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : 'DESC',
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
                poolId: query.poolId
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PoolVolume(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = { poolId: req.poolId };
            const queryParams = {
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path('pool/volume', routeParams, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    PoolsVolume(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                market: req.market,
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path('pools/volume', {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    CompetitionList(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('competition/list', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    VolumeCompetitionLeaderboard(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.assign(Object.assign(Object.assign({ competitionId: req.competitionId }, req.from && { from: req.from }), req.until && { until: req.until }), req.market && { market: req.market });
            const request = this.apiManager.path('competition/leaderboard', {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    PNLCompetitionLeaderboard(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = Object.assign({ competitionId: req.competitionId }, req.market && { market: req.market });
            const request = this.apiManager.path('competition/leaderboardpnl', {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    PoolsLiquidity(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                poolId: req.poolId,
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path('pools/liquidity', {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    MarketsVolume(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = {
                market: req.market,
                interval: req.interval,
                from: req.from,
                until: req.until,
            };
            const request = this.apiManager.path('market/volume', {}, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    // Node api
    Nodes(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('node/list', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    // Balance api
    BalanceTotal(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('balance/total', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceList(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('balance/list', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceChange(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('balance/change', req);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceHistory(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const routeParams = {
                address: req.address,
                denom: req.denom,
            };
            const queryParams = {
                interval: req.interval,
                limit: req.limit,
            };
            const request = this.apiManager.path('balance/history', routeParams, queryParams);
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceSupply() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('balance/supply');
            const response = yield request.get();
            return response.data;
        });
    }
    BalanceDistribution(req = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('balance/distribution', {}, req);
            const response = yield request.get();
            return response.data;
        });
    }
    // Positions api
    LiquidationEngine(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('position/liquidation/engine', {}, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : 'DESC',
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0
            });
            const response = yield request.get();
            return response.data;
        });
    }
    LiquidationAndADL(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('position/liquidation', {}, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : 'DESC',
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0
            });
            const response = yield request.get();
            return response.data;
        });
    }
    PositionsView(req, query) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('position/view', req, {
                sort: (_a = query.sort) !== null && _a !== void 0 ? _a : 'DESC',
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
                market: (_d = query.market) !== null && _d !== void 0 ? _d : ''
            });
            const response = yield request.get();
            return response.data;
        });
    }
    Leaderboard(req, query) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('position/leaderboard', req, {
                market: (_a = query.market) !== null && _a !== void 0 ? _a : '',
                sort: (_b = query.sort) !== null && _b !== void 0 ? _b : 'DESC',
                limit: (_c = query.limit) !== null && _c !== void 0 ? _c : 100,
                offset: (_d = query.offset) !== null && _d !== void 0 ? _d : 0,
                address: (_e = query.address) !== null && _e !== void 0 ? _e : '',
            });
            const response = yield request.get();
            return response.data;
        });
    }
    //Coin Gecko Tokens
    DenomToGeckoIdMap() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('info/denom_gecko_map');
            const response = yield request.get();
            return response.data;
        });
    }
    FundingHistory(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.apiManager.path('market/funding', {}, {
                market: (_a = query.market) !== null && _a !== void 0 ? _a : '',
                limit: (_b = query.limit) !== null && _b !== void 0 ? _b : 100,
                offset: (_c = query.offset) !== null && _c !== void 0 ? _c : 0,
            });
            const response = yield request.get();
            return response.data;
        });
    }
}
exports.default = InsightsQueryClient;
